export const BRAND_NAME = 'Deutsche Bank';
export const BRAND_LOGO_PATH = '/deutsche-bank-logo.svg';
export const DEUTSCHE_BANK_ROUTE_PREFIX = '/deutsche-bank';
export const DEUTSCHE_BANK_ACCOUNTS_BASE = '/v1/deutsche-bank/accounts';
export const ACCOUNTS_BASE = '/v1/accounts';

export const accountApiPath = (
  accountId: string | number,
  path = ''
) => `${ACCOUNTS_BASE}/${accountId}${path}`;

export const appPath = (path = '') => {
  if (!path) return DEUTSCHE_BANK_ROUTE_PREFIX;
  return `${DEUTSCHE_BANK_ROUTE_PREFIX}${path.startsWith('/') ? path : `/${path}`}`;
};
